import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';
import { IntegrityMonitorDefaultRuleConfigurationGzDataProvider } from '../dataProvider/IntegrityMonitorDefaultRuleConfigurationGzDataProvider';

export class IntegrityMonitorDefaultRuleConfigurationDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrityMonitorDefaultRuleConfigurationGzDataProvider);
  }
}
